import { CellContext } from '@tanstack/react-table';

import { Flex } from 'shared_DEPRECATED/components/Flex';

import {
  ParticipantsTableMessages,
  ParticipantsTableNextSessionHint,
} from 'features/participants/components/Table/Actions/';
import {
  CoachingMode,
  ParticipantsTableRowDataType,
} from 'features/participants/config/types';
import { NextSessionAppointment } from 'features/sessions/config/types';

export const ParticipantsTableActionsCell = ({
  row,
  table,
}: CellContext<ParticipantsTableRowDataType, CoachingMode>) => {
  const {
    nextSessionAppointment,
    userInfo,
    latestSprint,
    chatId,
    unreadChatMessagesNumber,
    isChatMarkedAsUnread,
    lastReadMessageId,
  } = row.original as unknown as {
    nextSessionAppointment: NextSessionAppointment;
    userInfo: any;
    latestSprint: any;
    chatId: string | null;
    unreadChatMessagesNumber: number;
    lastReadMessageId: string;
    isChatMarkedAsUnread: boolean;
  };

  const onChatOpen = (table.options.meta as any)?.onChatOpen;
  const isChatOpen = (table.options.meta as any)?.isChatOpen;

  return (
    <Flex gap="1rem" justifyContent="flex-start">
      <ParticipantsTableNextSessionHint
        coachingSessionId={nextSessionAppointment?.coachingSessionId}
        userInfo={userInfo}
      />
      <ParticipantsTableMessages
        userInfo={userInfo}
        latestSprint={latestSprint}
        chatId={chatId}
        unreadChatMessagesNumber={unreadChatMessagesNumber}
        isChatMarkedAsUnread={isChatMarkedAsUnread}
        onChatOpen={onChatOpen}
        lastReadMessageId={lastReadMessageId}
        isChatOpen={isChatOpen}
      />
    </Flex>
  );
};
